import { render, staticRenderFns } from "./frontMarcasPopulares.vue?vue&type=template&id=4dc4af5a&scoped=true&"
import script from "./frontMarcasPopulares.vue?vue&type=script&lang=js&"
export * from "./frontMarcasPopulares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4af5a",
  null
  
)

export default component.exports